import { NgModule } from '@angular/core';
import { AuthModule, LogLevel, provideAuth } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';
import { LoginErrorComponent } from './login-error/login-error.component';

@NgModule({
  providers: [
    provideAuth({
      config: {
        authority: `${environment.identity_provider}/realms/${environment.realm}/.well-known/openid-configuration`,
        redirectUrl: window.location.origin + '/login-ok',
        postLogoutRedirectUri: window.location.origin,
        clientId: environment.client_id,
        scope: 'openid profile',
        responseType: 'code',
        silentRenew: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        tokenRefreshInSeconds: 30,
        useRefreshToken: true,
        secureRoutes: environment.secureRoutes,
        logLevel: environment.production ? LogLevel.None : LogLevel.None,
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
